import Css from "./Css.js";
import { useTranslation } from 'react-i18next';

function UnSync(props){
  const {t} = useTranslation();
  const { editorWidth,toys,remoteDnPattern,pf } = props.data;
  const {retrySync,exitSync} = props.method;
  let toysArr = toys;
  let i18nKey = "";
  let tmp = "";
  if(toysArr.length === 1){
    i18nKey = " one toy synced";
    tmp =  toysArr[0] + t(i18nKey);
  }else if(toysArr.length >= 2){
    i18nKey = "two toys synced";
    tmp =  toysArr[0] + " " + t("and") + " " + toysArr[1] + " " + t(i18nKey);
  }else {
    i18nKey = "The toys are synced to video";
    tmp = t(i18nKey);
  }
  return (
    <>
      {
        pf === "Audiodesires_demo" ?<div style={ Css.unSyncArea2(editorWidth) }>
        {
          remoteDnPattern.rdnStatus === 2 ?
          <span style={ Css.unSyncBtn } onClick={ retrySync }>{t("Retry")}</span>
          :
          <span style={ Css.unSyncBtn } onClick={ exitSync }>{t("exomoon.audiodesires.text9")}</span>
        }
      </div>
      :
      <div style={ Css.unSyncArea(editorWidth) }>
        <span style={ Css.text }>{tmp}</span>
        {
          remoteDnPattern.rdnStatus === 2 ?
          <span style={ Css.unSyncBtn } onClick={ retrySync }>{t("Retry")}</span>
          :
          <span style={ Css.unSyncBtn } onClick={ exitSync }>{t("unsync")}</span>
        }
      </div>
      }
      
    </>
  )
}

export default UnSync;